import { useEffect, useState } from 'react';
import { t } from '../i18n/pt-BR';
import { Icon } from './Icon';
import {
  applyTheme,
  nextThemePreference,
  readThemePreference,
  saveThemePreference,
  type ThemePreference,
} from '../theme/theme';

const LABEL: Record<ThemePreference, string> = {
  system: t.theme.system,
  light: t.theme.light,
  dark: t.theme.dark,
};

export function ThemeToggle({ onDark = false }: { onDark?: boolean }) {
  const [pref, setPref] = useState<ThemePreference>(readThemePreference);

  useEffect(() => {
    applyTheme(pref);
  }, [pref]);

  return (
    <button
      type="button"
      className={`btn ghost${onDark ? ' on-dark' : ''}`}
      aria-label={`${t.theme.toggle}: ${LABEL[pref]}`}
      title={t.theme.toggle}
      onClick={() => {
        const next = nextThemePreference(pref);
        saveThemePreference(next);
        setPref(next);
      }}
    >
      <Icon name="sun" size={16} /> {t.theme.prefix}: {LABEL[pref]}
    </button>
  );
}
